<template>
<div :style="{height:height}" class="outer-wrapper">
    <img :src="url" alt="" class="img-item" v-for="(url,index) in imgList" :key="index" @click="tapOne(index)">
</div>
</template>
<script>
export default {
    name:"imgSlide",
    components: {
  },
  props:{
    height:{
      style:String,
      default(){
        return "200px";
      }
    },
    imgList:{
        style:Array,
        default(){
            return [];
        }
    }
    },
    mixins: [],
    data() {
        return {
            currentStartIndex:0,

        };
    },
    computed: {},
  methods: {
      tapOne(index){
          this.$emit('tapOne',index);
      }
  },
    
}
</script>
<style scoped>
    .outer-wrapper{
        display: flex;
        width:100%;
        overflow: hidden;
    }
    .img-item{
        height:100%;
        clear: both;
        display: inline-block;
        margin-right:0.2rem;
    }
</style>